import React from 'react';
import Stack, { StackProps } from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const TextIcon: React.FC<{
  text: string | React.ReactNode;
  icon: React.ReactNode;
  stackProps?: StackProps;
  startIcon?: boolean;
}> = ({ text, icon, stackProps, startIcon }) => {
  return (
    <Stack {...stackProps} direction="row" spacing={1} alignItems="center">
      {startIcon && icon}
      <Typography>{text}</Typography>
      {!startIcon && icon}
    </Stack>
  );
};

export default TextIcon;
